let URL = global.URL
if (!URL) {
    URL = require('url').URL
}

export default URL



// WEBPACK FOOTER //
// ./src/utils/URL.js